import { z } from 'zod';

/** Papéis de usuário (Prisma enum `role_usuario`). */
export const ROLES = ['admin', 'atendente', 'cliente'] as const;
export type RoleUsuario = (typeof ROLES)[number];

/** Conteúdo do access token. `clienteId` só existe para role `cliente`. */
export const tokenPayloadSchema = z.object({
  sub: z.string().uuid(),
  role: z.enum(ROLES),
  clienteId: z.string().uuid().nullable(),
});
export type TokenPayload = z.infer<typeof tokenPayloadSchema>;

export const loginSchema = z.object({
  identificador: z.string().trim().min(1), // email, login, ou telefone (cliente)
  senha: z.string().min(1),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const refreshSchema = z.object({
  refreshToken: z.string().min(1),
});

/** Regra de senha compartilhada por primeiro acesso e redefinição por link. */
export const senhaSchema = z.string().min(8, 'A senha precisa de pelo menos 8 caracteres');

export const primeiroAcessoSchema = z.object({
  token: z.string().min(1),
  senha: senhaSchema,
  aceitaTermos: z.literal(true, { message: 'É preciso aceitar os termos' }),
});
export type PrimeiroAcessoInput = z.infer<typeof primeiroAcessoSchema>;

export const recuperarSenhaSchema = z.object({
  identificador: z.string().trim().min(1), // email/login (equipe) ou telefone (cliente)
});

/**
 * `POST /auth/redefinir-senha` — troca a senha a partir do token de
 * `recuperacao_senha` (SPEC §8). Endpoint separado do primeiro acesso: não
 * reexige aceite de termos (semântica diferente — a pessoa já é usuária).
 */
export const redefinirSenhaSchema = z.object({
  token: z.string().min(1),
  senha: senhaSchema,
});
export type RedefinirSenhaInput = z.infer<typeof redefinirSenhaSchema>;

export const tokensResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  usuario: z.object({
    id: z.string().uuid(),
    role: z.enum(ROLES),
    clienteId: z.string().uuid().nullable(),
    nome: z.string().nullable(),
  }),
});
